import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
// import UploadDocument from "../../UploadDocument";
// import { ImageUploadInstructionDoc } from "../../../utils/constants";
// import Loader from "../../loaders/Loader";
import * as api from "../../../redux/api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { reactIcons } from "../../../utils/icons";
import CustomFileInput from "../../CustomFileInput";

const initialState = {
  businessRegistrationCertificate: [],
  taxIdentificationDocument: [],
  complianceCertifications: [],
  operationalPermitsAndLicenses: []
};

const DocumentationChecklist = () => {
  const [form, setForm] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [formError, setFormError] = useState({});
  const [isReadOnly, setIsReadOnly] = useState(false);

  const { id } = useParams();
  console.log("idcheck ", id);
  const location = useLocation();
  const { key } = location.state || {};
  console.log("doc", key);

  const getData = async () => {
    try {
      if (!id) return;

      const res = await api.getUserList(id);
      if (res.status && res.data) {
        const checklist = res.data.data.DocumentationChecklist || {};

        const transformToUrlObjects = (arr) =>
          arr?.map((url) => ({ url })) || [];

        const transformedData = {
          businessRegistrationCertificate: transformToUrlObjects(
            checklist.businessRegistrationCertificate
          ),
          taxIdentificationDocument: transformToUrlObjects(
            checklist.taxIdentificationDocument
          ),
          complianceCertifications: transformToUrlObjects(
            checklist.complianceCertifications
          ),
          operationalPermitsAndLicenses: transformToUrlObjects(
            checklist.operationalPermitsAndLicenses
          )
        };

        const isReadOnlyNow = Object.values(transformedData).some(
          (arr) => Array.isArray(arr) && arr.length > 0
        );
        setIsReadOnly(isReadOnlyNow);

        // Set form values
        setForm(transformedData);
      } else {
        console.error("Error fetching data:", res.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    let errors = {};

    if (!form.businessRegistrationCertificate.length) {
      errors.businessRegistrationCertificate =
        "Business Registration Certificate is required";
    }
    if (!form.taxIdentificationDocument.length) {
      errors.taxIdentificationDocument =
        "Tax Identification Document is required";
    }
    if (!form.operationalPermitsAndLicenses.length) {
      errors.operationalPermitsAndLicenses =
        "Operational Permits And Licenses  Document is required";
    }

    setFormError(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }

    setIsLoading(true);

    try {
      console.log(id);

      const payload = {
        organizationId: id,

        businessRegistrationCertificate:
          form.businessRegistrationCertificate.map((doc) => doc.url),
        taxIdentificationDocument: form.taxIdentificationDocument.map(
          (doc) => doc.url
        ),
        complianceCertifications: form.complianceCertifications.map(
          (doc) => doc.url
        ),
        operationalPermitsAndLicenses: form.operationalPermitsAndLicenses.map((doc) => doc.url)
      };

      const res = await api.registerChecklist(payload);
      if (res.status === 200 || res.status === 201) {
        toast.success("Documents submitted successfully");
        navigate(`/beneficial-ownership/${id}`, { state: { key } });
      } else {
        toast.error(res?.error?.message);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(
        error.response?.data?.message,
        "An error occurred while submitting the form"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange = (field, urls) => {
    setForm((prev) => ({
      ...prev,
      [field]: urls.map((url) => ({ name: url.split("/").pop(), url }))
    }));
    setFormError((prev) => ({ ...prev, [field]: "" }));
  };

  return (
    <div>
      <h2 className="text-black text-24 text-center">
        Documentation-Checklist
      </h2>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (key) {
            handleSubmit(e);
          } else if (id) {
            navigate(`/beneficial-ownership/${id}`);
          } else {
            handleSubmit(e);
          }
        }}
        className="border mt-5 border-yellow-dark p-5 rounded-[10px]"
      >
        <div className="grid grid-cols-2  items-start gap-4">
          <div>
            <label>
              Business Registration Certificate
              <span className="text-red-600">*</span>
            </label>
            <CustomFileInput
              allowedFormats=" PDF"
              name="businessRegistrationCertificate"
              defaultValue={form.businessRegistrationCertificate.map(
                (f) => f.url
              )}
              onChange={(urls) =>
                handleFileChange("businessRegistrationCertificate", urls)
              }
              disabled={isReadOnly}
            />
            {formError.businessRegistrationCertificate && (
              <div className="text-red-500 mt-1 text-sm">
                {formError.businessRegistrationCertificate}
              </div>
            )}
          </div>

          <div>
            <label>
              Tax Identification Document
              <span className="text-red-600">*</span>
            </label>

            <CustomFileInput
              allowedFormats=" PDF"
              name="taxIdentificationDocument"
              defaultValue={form.taxIdentificationDocument.map((f) => f.url)}
              onChange={(urls) =>
                handleFileChange("taxIdentificationDocument", urls)
              }
              disabled={isReadOnly}
            />
            {formError.taxIdentificationDocument && (
              <div className="text-red-500 mt-1 text-sm">
                {formError.taxIdentificationDocument}
              </div>
            )}
          </div>

          <div>
            <CustomFileInput
              label="Operational Permits Licenses"
              allowedFormats=" PDF"
              name="operationalPermitsAndLicenses"
              defaultValue={form.operationalPermitsAndLicenses.map(
                (f) => f.url
              )}
              // onChange={(urls) => {
              //   setForm((prev) => ({
              //     ...prev,
              //     operationalPermitsAndLicenses: urls.map((url) => ({
              //       name: url.split("/").pop(),
              //       url
              //     }))
              //   }));
              // }}
              onChange={(urls) =>
                handleFileChange("operationalPermitsAndLicenses", urls)
              }
              disabled={isReadOnly}
            />
            {formError.operationalPermitsAndLicenses && (
              <div className="text-red-500 mt-1 text-sm">
                {formError.operationalPermitsAndLicenses}
              </div>
            )}
          </div>
        </div>
        <div className="flex justify-between gap-4 items-center">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className={`btn btn-danger `}
          >
            {reactIcons.arrowleft} Back
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-primary "
          >
            {/* {isLoading ? <Loader /> : "Next "} */}
            Next{reactIcons.arrowright}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DocumentationChecklist;
